import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/user.svg',
})
export class UserComponent {}
